var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnDcu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 76,
    viewBox: "0 0 58 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn_dcu",
    transform: "translate(-25 -27.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4224",
    "data-name": "\\uD328\\uC2A4 4224",
    d: "M132.529,93.791a4.11,4.11,0,0,0-4.115,4.1v65.653a4.11,4.11,0,0,0,4.115,4.1h47.333a4.109,4.109,0,0,0,4.115-4.1V114.063L164.138,93.791Z",
    transform: "translate(-100.977 -63.853)",
    fill: "#b1b0af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4215",
    "data-name": "\\uD328\\uC2A4 4215",
    d: "M132.529,93.791a4.11,4.11,0,0,0-4.115,4.1v65.653a4.11,4.11,0,0,0,4.115,4.1h47.336a4.109,4.109,0,0,0,4.115-4.1l.2-46.658L160.94,93.8Z",
    transform: "translate(-103.414 -65.993)",
    fill: "#f3d096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4216",
    "data-name": "\\uD328\\uC2A4 4216",
    d: "M290.888,116.895H272.08a4.956,4.956,0,0,1-4.922-4.989V93.791Z",
    transform: "translate(-210.027 -65.993)",
    fill: "#f1ae40"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDcu);
export default __webpack_public_path__ + "static/media/btn_dcu.a83146ac6d30b4b1ecdb1e7478c1c7c3.svg";
export { ForwardRef as ReactComponent };